import React from 'react';
import { DealershipVehicleV1 } from '../../services/dealerships/types';
import { Icon } from 'lynkco-up-core';

type Props = {
  vehicle: DealershipVehicleV1;
  onClickDelete?: (vehicle: DealershipVehicleV1) => void;
};

const VehicleCard: React.FC<Props> = ({ vehicle, onClickDelete }) => {
  return (
    <div className="flex flex-col items-stretch border border-black rounded-lg max-w-md bg-white">
      {/* Profile Picture */}
      <div className="flex items-center">
        <img src={vehicle.vehicleDetails?.urlPicture} alt={`${vehicle.vin}'s profile`} className={`rounded-lg`} />
      </div>
      <div className="flex justify-between ">
        <div>
          {/* Text Section */}
          <div className="flex flex-col justify-center flex-grow-4 p-4">
            <p className="text-lg font-semibold">{vehicle.vin}</p>
            <p className="">Model Type: {vehicle.vehicleDetails?.modelType}</p>
            <p className="">Trim Level: {vehicle.vehicleDetails?.trimLevel}</p>
          </div>
        </div>
        <div className="flex mr-5">
          {onClickDelete && (
            <div onClick={() => onClickDelete(vehicle)} className="cursor-pointer bg-white rounded-full my-auto">
              <Icon variant="danger" size="large" name="delete"></Icon>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleCard;
